import { getAccountRollappTransactionRecord } from '@/api/account'
import { CheckinRecords_Record } from '@/api/account/interface'
import { useRequest } from 'ahooks'
import CheckinRecordsCard from './CheckinRecordsCard'
import { useEffect, useState } from 'react'
import LoadingCom from '@/components/LoadingCom'
import MeEmpty from '@/components/MeEmpty'

interface IProps {
  address: string
  activeValue: string
  checkinRecordsTab: 'hub' | 'rollapp_checkin'
  pageParams: {
    offset: number
    page: number
    limit: number
  }
  setTotal: (total: number) => void
  setLoading: (loading: boolean) => void
}

const CheckinRecords = ({
  address,
  activeValue,
  checkinRecordsTab,
  setTotal,
  pageParams,
  setLoading,
}: IProps) => {
  const [checkinRecords, setCheckinRecords] = useState<CheckinRecords_Record[]>([])

  const { loading, run } = useRequest(
    () =>
      getAccountRollappTransactionRecord({
        address,
        limit: pageParams.limit,
        offset: pageParams.offset,
      }),
    {
      ready: false,
      manual: true,
      onSuccess: (res) => {
        setCheckinRecords(res?.records || [])
        setTotal(res?.count?.aggregate?.count || 0)
      },
    },
  )

  useEffect(() => {
    run()
  }, [run, address, pageParams])

  useEffect(() => {
    setLoading(loading)
  }, [loading, setLoading])

  return (
    <>
      {activeValue === '0' && checkinRecordsTab === 'rollapp_checkin' && (
        <>
          {loading && <LoadingCom />}
          {!loading && checkinRecords.length === 0 && <MeEmpty />}
          {checkinRecords.map((item: CheckinRecords_Record) => {
            return (
              <CheckinRecordsCard
                address={address}
                cardData={item}
                key={`checkinRecordsCard${item.transition_hash + `${Math.random()}`}`}
              />
            )
          })}
        </>
      )}
    </>
  )
}

export default CheckinRecords
